import { pushGtmEvent } from '../helpers/analytics';
import { MapEstateViewer } from '../helpers/estate-map';
import { Loader } from '../helpers/Loader';
const { delegate, hideAll } = require('tippy.js');

class ApartmentsList {
    constructor(section) {
        if (!section) return;
        this.root = section;

        this.form = this.root.querySelector('form');
        this.isEmpty3d = this.root.getAttribute('data-empty-3d') == '1';
        this.maxPages = parseInt(this.root.getAttribute('data-max-pages'));
        this.cacheFormElements();

        this.listToBoxesButton = this.form.querySelectorAll('[js-change-view]');
        this.pagination = this.root.querySelector('[js-pagination]');
        this.tableSortElements = this.root.querySelectorAll('[data-sort]');

        this.viewButtons = this.form.querySelectorAll('[data-view-button]');
        this.js3dWrapper = this.root.querySelector('[js-3d-wrapper]');
        this.listBoxesWrapper = this.root.querySelector(
            '[js-list-boxes-wrapper]'
        );
        this.mdaEstateMap = this.root.querySelector('[data-estate-map]');
        this.mdaEstateMapInstance = null;
        this.listElement = this.listBoxesWrapper?.querySelector('[js-list]');
        this.boxesElement = this.listBoxesWrapper?.querySelector('[js-boxes]');

        this.totalElement = this.root.querySelector('[js-total-elements]');

        this.openFiltersButton = this.form.querySelector('[js-open-filters]');
        this.hideFiltersElements = this.root.querySelectorAll(
            '[js-hidden-3destate-element]'
        );
        this.hide3dElements = this.root.querySelectorAll(
            '[js-hidden-3d-element]'
        );
        this.estate3dEl = this.root.querySelector('[js-3destate]');
        this.estate3dId = this.estate3dEl
            ? this.estate3dEl.getAttribute('js-3destate')
            : null;
        this.model3dEstate = null;

        this.priceHistoryDelegate = null;
        this.priceHistoryLabels = JSON.parse(
            this.root.dataset.priceHistoryLabels || '{}'
        );

        this.loader = new Loader(this.form.querySelector('.loader'));

        this.init();
    }

    init() {
        if (
            this.estate3dEl &&
            this.estate3dId !== null &&
            this.estate3dId !== ''
        ) {
            this.set3dModel();
            this.initOn3dload();
        } else {
            if (this.mdaEstateMap) {
                this.mdaEstateMapInstance = new MapEstateViewer(
                    this.mdaEstateMap
                );
            }
            this.initPriceHistoryTooltips();
            this.initPriceInfoTooltips();
            this.initPlanButtonLabelTooltips();
            this.events();
        }
    }

    initOn3dload() {
        window.addEventListener('3destateloaded', event => {
            this.model3dEstate = event.detail;

            this.initPriceHistoryTooltips();
            this.initPriceInfoTooltips();
            this.initPlanButtonLabelTooltips();
            this.events();
        });
    }

    events() {
        if (this.listToBoxesButton) {
            this.listToBoxesButton.forEach(item => {
                item.addEventListener(
                    'click',
                    this.onListToBoxesButtonClick.bind(this)
                );
            });
        }

        if (this.viewButtons) {
            this.viewButtons.forEach(element => {
                element.addEventListener(
                    'click',
                    this.onViewButtonClick.bind(this)
                );
            });
        }

        if (this.form) {
            this.form.addEventListener('input', this.onFormInput.bind(this));
            this.form.addEventListener('submit', this.onFormSubmit.bind(this));
        }

        window.addEventListener('click', this.onPaginationClick.bind(this));
        window.addEventListener(
            'click',
            this.onTableSortElementClick.bind(this)
        );

        if (this.openFiltersButton && this.filtersElement) {
            this.openFiltersButton.addEventListener(
                'click',
                this.openMobileFilters.bind(this)
            );
        }

        this.bindCloseFiltersButtons();
        this.bindEstateRadioButtons();
        this.bindSurfaceRadioButtons();

        const initiallySelectedEstate = [...this.estateRadios].find(
            input => input.checked
        );
        this.syncEstateSelection(initiallySelectedEstate?.value || '');
    }

    cacheFormElements() {
        this.viewInput = this.form.querySelector("[name='view']");
        this.sortSelect = this.form.querySelector("[name='sort']");
        this.sortSelectCustomItems =
            this.sortSelect?.parentElement?.querySelectorAll(
                '[js-select-item]'
            ) || [];

        this.mobileSort = this.form.querySelector("[name='sort_mobile']");
        this.mobileSortSelectCustomItems =
            this.mobileSort?.parentElement?.querySelectorAll(
                '[js-select-item]'
            ) || [];

        this.pageInput = this.form.querySelector("[name='page']");
        this.filtersElement = this.root.querySelector('[js-filters]');
        this.closeFiltersButtons = this.form.querySelectorAll(
            '[js-close-mobile-filters]'
        );
        this.estateRadios = this.form.querySelectorAll('[data-estate-radio]');
        this.surfaceRadios = this.form.querySelectorAll('[data-surface-radio]');
        this.investmentInputsWrapper = this.form.querySelector(
            '[js-estate-investments-inputs]'
        );
        this.surfaceFilterWrapper = this.root.querySelector(
            '[js-surface-filter-wrapper]'
        );
    }

    bindCloseFiltersButtons() {
        if (!this.closeFiltersButtons.length || !this.filtersElement) return;

        this.closeFiltersButtons.forEach(element => {
            if (element.dataset.closeFiltersBound === '1') return;

            element.dataset.closeFiltersBound = '1';
            element.addEventListener(
                'click',
                this.closeMobileFilters.bind(this)
            );
        });
    }

    bindEstateRadioButtons() {
        if (!this.estateRadios.length) return;

        this.estateRadios.forEach(element => {
            if (element.dataset.estateRadioBound === '1') return;

            element.dataset.estateRadioBound = '1';
            element.addEventListener(
                'change',
                this.onEstateRadioChange.bind(this)
            );
        });
    }

    bindSurfaceRadioButtons() {
        if (!this.surfaceRadios.length) return;

        this.surfaceRadios.forEach(element => {
            if (element.dataset.surfaceRadioBound === '1') return;

            element.dataset.surfaceRadioBound = '1';
            element.addEventListener(
                'change',
                this.onSurfaceRadioChange.bind(this)
            );
        });
    }

    openMobileFilters() {
        this.filtersElement.classList.add('-active');
    }

    closeMobileFilters() {
        this.filtersElement.classList.remove('-active');
    }

    onTableSortElementClick(e) {
        const sortElement = e.target.closest('[data-sort]');
        if (!sortElement) return;
        const isActive = sortElement.classList.contains('-active');
        this.tableSortElements.forEach(element =>
            element.classList.remove('-active')
        );

        if (!isActive) {
            sortElement.classList.add('-active');
        }

        const sortValueToSet = `${sortElement.getAttribute('data-sort')}-${
            isActive ? 'desc' : 'asc'
        }`;

        if (this.sortSelectCustomItems.length) {
            this.sortSelectCustomItems.forEach(item => {
                const itemValue = item.getAttribute('data-value');

                if (itemValue === sortValueToSet) {
                    item.dispatchEvent(new Event('click'));
                }
            });
        }
    }

    onPaginationClick(e) {
        const paginationEl = e.target.closest('[data-pagination]');
        if (!paginationEl) return;

        const pageToSet = paginationEl.getAttribute('data-pagination');
        this.pageInput.value = pageToSet;

        this.fetchData(false);
    }

    onFormSubmit(e) {
        e.preventDefault();
        if (window.innerWidth >= 1024) return;
        e.preventDefault();
        this.pageInput.value = '1';

        const sortValue = this.mobileSort.value;

        this.sortSelect.value = sortValue;

        if (this.sortSelectCustomItems.length) {
            this.sortSelectCustomItems.forEach(item => {
                const itemValue = item.getAttribute('data-value');

                if (itemValue === sortValue) {
                    item.dispatchEvent(new Event('click'));
                }
            });
        }

        this.fetchData(true);
    }

    onViewButtonClick(e) {
        const button = e.target.closest('button');
        if (!button) return;

        this.viewButtons.forEach(element =>
            element.classList.remove('-active')
        );

        const type = button.getAttribute('data-view-button');

        if (type === '3d') {
            this.js3dWrapper.classList.remove('hidden');
            this.listBoxesWrapper.classList.add('hidden');
            this.pagination.classList.add('hidden');
        } else {
            this.js3dWrapper.classList.add('hidden');
            this.listBoxesWrapper.classList.remove('hidden');

            if (this.maxPages > 1) {
                this.pagination.classList.remove('hidden');
            }
        }

        if (!this.isEmpty3d && this.hideFiltersElements.length) {
            this.hideFiltersElements.forEach(element => {
                if (type === '3d') {
                    element.classList.add('hidden!');
                } else {
                    element.classList.remove('hidden!');
                }
            });
        }

        if (this.hide3dElements.length) {
            this.hide3dElements.forEach(element => {
                if (type === '3d') {
                    element.classList.add('hidden!');
                } else {
                    element.classList.remove('hidden!');
                }
            });
        }

        button.classList.add('-active');
    }

    onListToBoxesButtonClick(e) {
        const { target } = e;
        const button = target.closest('button');
        if (!button) return;

        const allButtons = this.root.querySelectorAll('[js-change-view]');
        if (allButtons) {
            allButtons.forEach(item => item.classList.remove('-active'));
        }

        const buttonListType = button.getAttribute('js-change-view');
        if (!buttonListType) return;

        this.viewInput.value = buttonListType;
        button.classList.add('-active');

        if (buttonListType == 'list') {
            this.listElement.classList.remove('hidden');
            this.boxesElement.classList.add('hidden');
        } else if (buttonListType == 'boxes') {
            this.listElement.classList.add('hidden');
            this.boxesElement.classList.remove('hidden');
        }

        this.createUrl();
    }

    onFormInput(e) {
        if (window.innerWidth < 1024) return;
        e.preventDefault();
        const target = e.target;
        const { detail } = e;

        if (
            target?.name === 'estate' ||
            target?.name === 'apartment_surfaces_list[]' ||
            target?.name === 'apartment_surfaces_list_all'
        ) {
            return;
        }
        if (detail?.field === 'sort_mobile') return;

        this.pageInput.value = '1';

        if (detail?.field === 'sort') {
            this.handleSortSelectChange(detail.value);
        }

        this.fetchData(true);
    }

    onEstateRadioChange(e) {
        const radio = e.target.closest('[data-estate-radio]');
        if (!radio) return;

        const selectedEstateId = radio.checked ? radio.value : '';

        this.syncEstateSelection(selectedEstateId, radio);

        this.resetFiltersForEstateChange();
        const investmentIds = selectedEstateId
            ? JSON.parse(radio.dataset.investmentIds || '[]')
            : JSON.parse(
                  this.investmentInputsWrapper?.dataset.allInvestmentIds || '[]'
              );

        this.replaceInvestmentInputs(investmentIds);
        this.fetchData(true);
    }

    syncEstateSelection(selectedEstateId = '', preferredInput = null) {
        let checkedInput = false;

        this.estateRadios.forEach(input => {
            const isSelected = String(input.value) === String(selectedEstateId);
            const shouldBeChecked =
                isSelected &&
                !checkedInput &&
                (!preferredInput || input === preferredInput);

            input.checked = shouldBeChecked;

            if (shouldBeChecked) {
                checkedInput = true;
            }

            const option = input.closest('[data-estate-option]');
            const label = option?.querySelector('span');

            if (label) {
                label.classList.toggle('bg-black', isSelected);
                label.classList.toggle('text-white', isSelected);
                label.classList.toggle('border-black', isSelected);
                label.classList.toggle('bg-transparent', !isSelected);
                label.classList.toggle('text-black', !isSelected);
                label.classList.toggle('border-gray-60', !isSelected);
            }
        });

        // The preferred control may have been replaced by the AJAX response.
        if (selectedEstateId && !checkedInput) {
            const firstMatch = [...this.estateRadios].find(
                input => String(input.value) === String(selectedEstateId)
            );

            if (firstMatch) {
                firstMatch.checked = true;
            }
        }
    }

    onSurfaceRadioChange(e) {
        const input = e.target.closest('[data-surface-radio]');
        if (!input) return;

        const isAllOption = input.dataset.surfaceAll === '1';

        if (isAllOption) {
            if (!input.checked) {
                input.checked = true;
            }

            this.surfaceRadios.forEach(element => {
                if (element === input || element.dataset.surfaceAll === '1') {
                    return;
                }

                element.checked = false;
            });
        } else {
            if (input.checked) {
                const allOption = [...this.surfaceRadios].find(
                    element => element.dataset.surfaceAll === '1'
                );

                if (allOption) {
                    allOption.checked = false;
                }
            }

            const checkedSurfaces = [...this.surfaceRadios].filter(
                element => element.dataset.surfaceAll !== '1' && element.checked
            );

            if (!checkedSurfaces.length) {
                const allOption = [...this.surfaceRadios].find(
                    element => element.dataset.surfaceAll === '1'
                );

                if (allOption) {
                    allOption.checked = true;
                }
            }
        }

        this.pageInput.value = '1';
        this.fetchData(true);
    }

    handleSortSelectChange(sortValue) {
        const sortValueArray = sortValue.split('-');

        if (this.mobileSortSelectCustomItems.length) {
            this.mobileSortSelectCustomItems.forEach(item => {
                const itemValue = item.getAttribute('data-value');
                item.classList.remove('-checked');

                if (itemValue === sortValue) {
                    item.dispatchEvent(new Event('click'));
                }
            });
        }

        if (this.tableSortElements.length) {
            this.tableSortElements.forEach(element => {
                const elementSortType = element.getAttribute('data-sort');
                element.classList.remove('-active');

                if (sortValue.length) {
                    if (
                        sortValueArray[1] === 'asc' &&
                        sortValueArray[0] == elementSortType
                    ) {
                        element.classList.add('-active');
                    }
                }
            });
        }
    }

    async fetchData(trackSearch = false) {
        try {
            this.loader.show();
            const data = new FormData(this.form);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: data,
            });

            const res = await req.json();

            const { html, max_num_pages, total_elements, estateDetails } =
                res.data;

            const {
                html_filters,
                html_surface_filter,
                html_list_boxes,
                html_pagination,
            } = html;

            if (typeof html_filters === 'string' && this.filtersElement) {
                this.filtersElement.innerHTML = html_filters;
                this.initDynamicFormSelects(this.filtersElement);
                this.cacheFormElements();
                this.bindCloseFiltersButtons();
                this.bindEstateRadioButtons();
                this.bindSurfaceRadioButtons();
            }

            if (
                typeof html_surface_filter === 'string' &&
                this.surfaceFilterWrapper
            ) {
                this.surfaceFilterWrapper.innerHTML = html_surface_filter;
                this.cacheFormElements();
                this.bindCloseFiltersButtons();
                this.bindEstateRadioButtons();
                this.bindSurfaceRadioButtons();
            }

            this.syncEstateSelection(String(data.get('estate') || ''));

            if (this.mdaEstateMapInstance && estateDetails) {
                this.mdaEstateMapInstance.refreshContext(estateDetails);
            }

            if (html_list_boxes && this.listBoxesWrapper) {
                hideAll();
                this.listBoxesWrapper.innerHTML = html_list_boxes;
                this.listElement =
                    this.listBoxesWrapper?.querySelector('[js-list]');
                this.boxesElement =
                    this.listBoxesWrapper?.querySelector('[js-boxes]');
            }

            if (html_pagination && this.pagination) {
                this.pagination.innerHTML = html_pagination;
            }

            this.maxPages = max_num_pages;

            if (max_num_pages <= 1) {
                this.pagination.classList.add('hidden');
            } else {
                this.pagination.classList.remove('hidden');
            }

            if (this.totalElement) {
                this.totalElement.textContent = total_elements;
            }

            if (trackSearch) {
                this.trackSearch(data, total_elements);
            }

            if (this.model3dEstate) {
                const { apartments } = estateDetails;

                const crmIds =
                    apartments.length > 0
                        ? apartments.map(item => {
                              return item.crm_id;
                          })
                        : [];

                let matches = [];
                if (crmIds.length > 0) {
                    matches = [
                        {
                            values: crmIds,
                        },
                    ];
                }

                this.model3dEstate.unitFiltersSet([
                    {
                        filterType: 'match',
                        unitValue: { $g: 'customCrmId' },
                        matches: matches,
                    },
                ]);
            }

            this.createUrl(data);
        } catch (error) {
            console.log(error);
        } finally {
            this.loader.hide();
        }
    }

    trackSearch(data, totalElements) {
        const values = name => data.getAll(name).filter(Boolean);
        const estateInput = [...this.estateRadios].find(input => input.checked);
        const estateOption = estateInput?.closest('[data-estate-option]');

        pushGtmEvent('Wyszukiwarka_mieszkan', {
            osiedle: estateOption?.querySelector('span')?.textContent?.trim(),
            id_osiedla: data.get('estate'),
            dostepnosc: data.get('apartment_status'),
            pokoje: data.get('apartment_rooms'),
            pietro: data.get('apartment_floor'),
            metraz_od: data.get('from_apartment_surface'),
            metraz_do: data.get('to_apartment_surface'),
            pomieszczenia: values('apartment_surfaces_list[]').join(','),
            sortowanie: data.get('sort'),
            liczba_wynikow: totalElements,
        });
    }

    createUrl(data = null) {
        let formData = data;
        if (!data) {
            formData = new FormData(this.form);
        }
        const params = new URLSearchParams();

        for (const [key, value] of formData.entries()) {
            if (
                value === '' ||
                value === null ||
                value === undefined ||
                key === 'action' ||
                key === 'investment' ||
                key === 'investment[]' ||
                key === 'apartment_surfaces_list_all' ||
                key === 'sort_mobile' ||
                (key === 'page' && String(value) === '1') ||
                (key === 'view' && String(value) === 'list')
            ) {
                continue;
            }

            params.append(key, value);
        }

        const query = params.toString();

        const url = query
            ? `${window.location.pathname}?${query}`
            : window.location.pathname;
        window.history.pushState({}, '', url);
    }

    resetFiltersForEstateChange() {
        const fields = this.form.querySelectorAll('select, input, textarea');

        fields.forEach(field => {
            const name = field.name || '';

            if (
                !name ||
                name === 'action' ||
                name === 'view' ||
                name === 'page' ||
                name === 'estate' ||
                name === 'investment[]'
            ) {
                return;
            }

            if (field.tagName === 'SELECT') {
                field.value = '';
                this.syncCustomSelect(field);
                return;
            }

            if (field.type === 'checkbox' || field.type === 'radio') {
                field.checked = false;
                return;
            }

            if (field.type !== 'hidden') {
                field.value = '';
            }
        });

        this.pageInput.value = '1';
        this.handleSortSelectChange('');
    }

    syncCustomSelect(select) {
        const wrapper = select.closest('[js-form-select]');
        if (!wrapper) return;

        const activeText = wrapper.querySelector('[js-active-element-text]');
        const items = wrapper.querySelectorAll('[js-select-item]');
        const selectedItem = [...items].find(
            item => item.dataset.value === select.value
        );

        items.forEach(item => item.classList.remove('-checked'));

        if (selectedItem) {
            selectedItem.classList.add('-checked');
        }

        if (activeText) {
            activeText.textContent = selectedItem?.dataset.label
                ? selectedItem.dataset.label
                : wrapper.dataset.baseValue || '';
        }
    }

    replaceInvestmentInputs(ids) {
        if (!this.investmentInputsWrapper) return;

        this.investmentInputsWrapper.innerHTML = '';

        ids.forEach(id => {
            const input = document.createElement('input');

            input.type = 'hidden';
            input.name = 'investment[]';
            input.value = id;

            this.investmentInputsWrapper.appendChild(input);
        });
    }

    initDynamicFormSelects(scope) {
        if (typeof window.mdaInitFormSelects === 'function') {
            window.mdaInitFormSelects(scope);
        }
    }

    initPriceInfoTooltips() {
        delegate(this.root, {
            target: '[js-tippy-click]',
            trigger: 'click',
            allowHTML: true,
            content: reference =>
                reference.getAttribute('js-tippy-click') || '',
        });
    }

    initPlanButtonLabelTooltips() {
        delegate(this.root, {
            target: '[js-tippy]',
            allowHTML: true,
            touch: false,
            content: reference => reference.getAttribute('js-tippy') || '',
            onShow: () => this.isDesktop(),
        });
    }

    initPriceHistoryTooltips() {
        this.priceHistoryDelegate = delegate(this.root, {
            target: '[js-price-history-button]',
            appendTo: document.body,
            allowHTML: true,
            placement: 'right-start',
            offset: [-10, 8],
            theme: 'price-history',
            trigger: 'click',
            interactive: true,
            maxWidth: '90vw',
            content: reference => {
                const raw = reference.getAttribute(
                    'js-price-history-button-data'
                );
                if (!raw) return '';

                try {
                    return this.createHistoryTooltip(JSON.parse(raw));
                } catch {
                    return '';
                }
            },
            popperOptions: {
                strategy: 'fixed',
                modifiers: [
                    {
                        name: 'eventListeners',
                        options: {
                            scroll: false,
                            resize: true,
                        },
                    },
                    {
                        name: 'computeStyles',
                        options: {
                            adaptive: false,
                            gpuAcceleration: true,
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                            padding: 8,
                        },
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['left', 'bottom', 'top'],
                        },
                    },
                ],
            },
            onShow: () => {
                if (!this.isDesktop()) return;
                this.lockScroll();
            },
            onHide: () => {
                if (!this.isDesktop()) return;
                this.unlockScroll();
            },
            onMount: instance => {
                const closeBtn = instance.popper.querySelector(
                    '[js-close-history-tooltip]'
                );

                if (closeBtn) {
                    closeBtn.addEventListener('click', () => instance.hide());
                }
            },
        });
    }

    isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches;
    }

    formatPrice(price) {
        const cleaned = String(price)
            .replace(/[^\d,\.]/g, '')
            .replace(',', '.');
        const num = parseFloat(cleaned) || 0;
        const [integerPart, decimalPart] = num.toFixed(2).split('.');
        const formattedInteger = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ' '
        );

        return `${formattedInteger},${decimalPart}`;
    }

    formatHistoryPrice(price, suffix = '') {
        if (price === null || price === undefined || price === '') {
            return '-';
        }

        return `${this.formatPrice(price)}${suffix}`;
    }

    createHistoryTooltip(data) {
        if (!Array.isArray(data) || !data.length) return '';

        const { title, date, price, pricePerMeter } = this.priceHistoryLabels;
        const pricePerMeterLabel = (pricePerMeter || '').replace(
            'm²',
            'm<sup>2</sup>'
        );
        const rows = data
            .map((item, index) => {
                const borderClass =
                    index < data.length - 1 ? ' border-b border-gray-40' : '';

                return `
                    <div class="grid grid-cols-3 gap-18 p-16 bg-gray-10${borderClass}">
                        <p class="text-regular">${
                            item.history_price_date || ''
                        }</p>
                        <p class="text-regular">${this.formatHistoryPrice(
                            item.history_price,
                            ' zł'
                        )}</p>
                        <p class="text-regular">${this.formatHistoryPrice(
                            item.history_price_per_meter,
                            ' zł/m<sup>2</sup>'
                        )}</p>
                    </div>
                `;
            })
            .join('');

        return `
            <div class="shadow-[8px_8px_32px_0px_#0000001F] rounded-small overflow-hidden min-w-[90vw] desktop:min-w-[488px] text-start">
                <div class="flex items-center justify-between p-16 bg-gray-40">
                    <p class="text-large">${title || ''}</p>
                    <button type="button" class="cursor-pointer" js-close-history-tooltip>
                        <i class="icon icon-close text-[20px]! flex"></i>
                    </button>
                </div>
                <div class="grid grid-cols-3 gap-18 p-16 bg-gray-20">
                    <p class="text-tiny text-gray-100">${date || ''}</p>
                    <p class="text-tiny text-gray-100">${price || ''}</p>
                    <p class="text-tiny text-gray-100">${pricePerMeterLabel}</p>
                </div>
                ${rows}
            </div>
        `;
    }

    lockScroll() {
        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;

        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    unlockScroll() {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }

    set3dModel() {
        this.load3destate();
    }

    load3destate() {
        const id = this.estate3dId;

        const script = document.createElement('script');
        script.src =
            'https://oneappappsprd.blob.core.windows.net/$web/launcher/production/app.js';
        script.type = 'text/javascript';
        script.onload = function () {
            window.AppLauncher3DEOA.init({
                appId: id,
                rootElement: 'sm3de',
                props: {
                    initLang: 'pl',
                    unitFilterOverride: {},
                },
            }).then(appInstance => {
                const event = new CustomEvent('3destateloaded', {
                    detail: appInstance,
                });
                window.dispatchEvent(event);
            });
        }.bind(this);
        document.head.append(script);
    }
}

const sections = document.querySelectorAll('section.apartments-list');

if (sections.length) {
    sections.forEach(element => {
        new ApartmentsList(element);
    });
}
